<mat-dialog-content class="mat-typography" dirEnter (dirSubmit)="!form.valid || isSubmit ? null : onSubmit()">
    <div class="container form_wrapper">
        <div class="title_modal d-f-c">
            {{ "Editing partner workspace" | translate }}:
            <div class="company_name d-f-c ml-1">
                <ng-container *ngIf="!!data.partner?.partnerCompany?.avatarFile?.thumbnail && !!data.host; else elseTemplatePartnerAvatar">
                    <img class="partner_avatar" (error)="onPartnerImgError($event)" [src]="data.host + data.partner?.partnerCompany?.avatarFile?.thumbnail + '?company_id=' + data.company_id" alt="">
                </ng-container>
                <ng-template #elseTemplatePartnerAvatar>
                    <img class="partner_avatar" (error)="onPartnerImgError($event)" src="{{ imgRoute }}assets/img/partner.png">
                </ng-template>
                <span class="ml-1">{{data.partner?.partnerCompany?.name}}</span>
            </div>
        </div>

        <form [formGroup]="form" class="form_with_pads form_with_valids">

            <mat-form-field appearance="standard" class="full_width_form">
                <mat-label>{{ "Choose a currency" | translate }}</mat-label>
                <mat-select formControlName="currency_id" required [disabled]="disableSelect">
                <mat-option *ngFor="let currency of currencyList" [value]="currency.id">
                    {{ currency.name }}
                </mat-option>
                </mat-select>
            </mat-form-field>
    
            <mat-form-field appearance="standard" class="full_width_form">
                <mat-label>{{ 'Points' | translate }}</mat-label>
                <input formControlName="rate_target" matInput type="number" placeholder="{{ 'Points' | translate }}">
            </mat-form-field>
    
            <mat-form-field appearance="standard" class="full_width_form">
                <mat-label>{{ 'Salary' | translate }}</mat-label>
                <input formControlName="salary" matInput type="number" placeholder="{{ 'Salary' | translate }}">
            </mat-form-field>
    
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="f_w_p_btns">
        <button mat-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1 d-f-btn" (click)="onSubmit()" cdkFocusInitial mat-raised-button color="primary" [disabled]="isSubmit">
            <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>  
            {{ "Save" | translate }}
        </button>
    </div>
</mat-dialog-actions>
